import { CoreConstants } from '../core.constants';
import { UnitOfMeasure } from '../enums/unit-of-measure';

export function uomSwitch(value: string, type: 'door' | 'frame', unitOfMeasure: UnitOfMeasure): number {
  const num = value?.fromDimension(type, UnitOfMeasure.Imperial);
  return unitOfMeasure === UnitOfMeasure.Imperial
    ? num
    : Math.round((num / CoreConstants.multipliers.doorElevation) * 25.4);
}
